import { FC, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { useTranslation } from 'src/components/authentication/i18n';
import { useSnackbar } from 'notistack';
import { useAuth } from 'src/contexts/JWTContext';
import { useSettings } from 'src/contexts/SettingsContext';
import useGeneralError from 'src/hooks/useGeneralError';
import {
  ButtonProps,
} from 'material-hu';
import {
  getAzureInstances,
} from 'src/services/authService';
import microsoftLogo from 'src/assets/microsoft.svg';
import LoginButton from 'src/pages/authentication/components/LoginButton';
import 'src/components/authentication/i18n';

export type AzureLoginProps = ButtonProps & {
  onLogin: () => void;
  onLoginFinally: () => void;
};

export const AzureLogin: FC<AzureLoginProps> = (props) => {
  const {
    onLogin = () => null,
    onLoginFinally = () => null,
    ...buttonProps
  } = props;

  const { t } = useTranslation();
  const showGeneralError = useGeneralError();
  const { enqueueSnackbar } = useSnackbar();
  const { azureLogin } = useAuth();
  const { setPrimary, resetPrimary } = useSettings();
  const { instance } = useMsal();

  useEffect(() => {
    resetPrimary();
  }, [resetPrimary]);


  const handleLogin = async () => {
    try {
      onLogin();
      const { accessToken } = await instance.acquireTokenPopup({
        scopes: ['profile', 'openid', 'User.Read'],
        redirectUri: '/blank.html',
        prompt: 'select_account',
      });

      const response = await getAzureInstances(accessToken);
      if (response.data?.length) {
        const instance = response.data[0];
        setPrimary(instance.color);
        const body = {
          accessToken,
          instanceId: instance.id,
        };
        await azureLogin(body);
      }
      else {
        enqueueSnackbar(
          t('ERROR_AZURE_GET_INSTANCES'),
          { variant: 'error' },
        );
      }
    }
    catch (err) {
      if (err?.message?.includes('interaction_in_progress')) {
        showGeneralError(err, t('WARNING_AZURE_LOGIN_INTERACTION_IN_PROGRESS'), false);
      }
      else {
        showGeneralError(err, t('ERROR_AZURE_LOGIN'));
      }
    }
    finally {
      onLoginFinally();
    }
  };

  return (
    <LoginButton
      logo={microsoftLogo}
      label="Microsoft"
      onClick={handleLogin}
      {...buttonProps}
    />
  );
};

export default AzureLogin;
